import { EnergyCalculatorService } from './EnergyCalculatorService'

import { appConfig } from 'Config'

export const energyCalculatorService = new EnergyCalculatorService({
  baseURL: appConfig.energyCalculatorService.baseUrl
})
